import {
  getMediaList,
  getEventList,
  getAddAttributesTemplate,
  createAddAttribute,
  createMediaElement,
  getMediaElementTemplate,
  getEventTemplate,
  createEvent,
  eventPriceTemplate,
  addEventPrice,
  updateEventPrice,
  deleteEventPrice,
  viewEventDataById,
  deleteEvent,
  updateEvent,
  updateMediaElement,
  editMediaElementData,
  dataByIdMedia,
} from "@/http/setup/mediaDetails.js";

export default {
  namespaced: true,
  state: {
    Medialist: [],
    Eventlist: [],
    AddAttributeTemplateList: {},
    createAttributeList: null,
    mediaTemplate: {},
    eventTemplate: {},
    addPriceTemplate: {},
    eventViewById: null,
  },
  actions: {
    async dataByIdMediaAction(_, id) {
      try {
        const resp = await dataByIdMedia(id);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async editMediaElementDataAction(_, id) {
      try {
        const resp = await editMediaElementData(id);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updateMediaElementAction(_, payload) {
      try {
        const resp = await updateMediaElement(payload);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setMediaList({ commit }) {
      try {
        const resp = await getMediaList();
        commit("SET_MEDIA", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createMediaElementAction(_, data) {
      try {
        const resp = await createMediaElement(data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deleteEventAction(_, data) {
      try {
        const resp = await deleteEvent(data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updateEventAction(_, payload) {
      try {
        const resp = await updateEvent(payload.id, payload.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createEventAction(_, data) {
      try {
        const resp = await createEvent(data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async addEventPriceAction(_, payload) {
      try {
        const resp = await addEventPrice(payload.id, payload.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updateEventPriceAction(_, payload) {
      try {
        const resp = await updateEventPrice(payload.id, payload.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deleteEventPriceAction(_, payload) {
      try {
        const resp = await deleteEventPrice(payload);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setEventList({ commit }) {
      try {
        const resp = await getEventList();
        commit("SET_EVENT", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async viewEventDataByIdAction({ commit }, data) {
      try {
        const resp = await viewEventDataById(data);
        commit("SET_EVENT_BY_ID", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async eventPriceTemplateAction({ commit }, data) {
      try {
        const resp = await eventPriceTemplate(data);
        commit("SET_EVENT_PRICE_TEMPLATE", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getEventTemplateAction({ commit }) {
      try {
        const resp = await getEventTemplate();
        commit("SET_EVENT_TEMPLATE", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getMediaElementTemplateAction({ commit }) {
      try {
        const resp = await getMediaElementTemplate();
        commit("SET_MEDIA_TEMPLATE", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setAddAttributesTemplate({ commit }) {
      try {
        const resp = await getAddAttributesTemplate();
        commit("SET_ADD_ATTRIBUTE_TEMPLATE", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createattributeAction({ commit }, data) {
      try {
        const resp = await createAddAttribute(data.id, data.data);
        commit("CREATE_ADD_ATTRIBUTE_ACTION", resp.data.mediaId);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  mutations: {
    SET_MEDIA(state, payload) {
      Object.assign(state, { Medialist: payload });
    },
    SET_EVENT(state, payload) {
      Object.assign(state, { Eventlist: payload });
    },
    SET_ADD_ATTRIBUTE_TEMPLATE(state, payload) {
      Object.assign(state, { AddAttributeTemplateList: payload });
    },
    CREATE_ADD_ATTRIBUTE_ACTION(state, payload) {
      Object.assign(state, { createAttributeList: payload });
    },
    SET_MEDIA_TEMPLATE(state, payload) {
      state.mediaTemplate = payload;
    },
    SET_EVENT_TEMPLATE(state, payload) {
      state.eventTemplate = payload;
    },
    SET_EVENT_PRICE_TEMPLATE(state, payload) {
      state.addPriceTemplate = payload;
    },
    SET_EVENT_BY_ID(state, payload) {
      state.eventViewById = payload;
    },
  },
  getters: {
    Medialist(state) {
      return state.Medialist;
    },
  },
};
